import styled from "@emotion/styled";

export const IconBox = styled.div`
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.background};
  transition: background-color 0.3s ease;

  @media (min-width: ${({ theme }) => theme.screenSizes.mdMax}) {
    width: 52px;
    height: 52px;
  }

  ${props => props.addStyles}
`;
